<template>
    <div>
      <div class="desc">
        <!--{{value}}-->
      </div>

    </div>
</template>
<script>
    export default {
        data() {
            return {}
        },
        props: {
          value:{

          }
        },
        methods: {},
        computed: {},
        mounted() {
          // console.log(this.value);
          document.getElementsByClassName('desc')[0].innerHTML = this.value;
        }
    }
</script>
<style scoped lang="scss">
  div{
    font-size: 0.28rem;
  }
  .desc{
    height: 100%;

    padding: 0.12rem 0.3rem 0.3rem 0.3rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/container/course.vue